export default "__VITE_ASSET__CVM0cmws__"